import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ValueAddThreeTypeAdapter } from './dto/value-addition-three.adapter';
import { ValueAdditionThreeType } from './value-addition-three.entity';
import { ValueAddition3TypesController } from './value-addition3-types.controller';
import { ValueAddition3TypesService } from './value-addition3-types.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([ValueAdditionThreeType]),
  ],
  controllers: [ValueAddition3TypesController],
  providers: [ValueAddition3TypesService,ValueAddThreeTypeAdapter,ApplicationExceptionHandler,LogsService],
  exports: [ValueAddition3TypesService]
})
export class ValueAddition3TypesModule {}
